// @flow
// $FlowFixMe
import React from 'react';
import {connect} from 'react-redux';
import {TripBoardsModalApolloProvider} from '@homeaway/react-trip-board-button';

type TripBoardsProviderContainerProps = {
    siteName: string,
    isLoggedIn: boolean,
    tripBoardProviderSearchParams: Object
};
function TripBoardsProviderContainer({
    siteName,
    tripBoardProviderSearchParams,
    isLoggedIn
}: TripBoardsProviderContainerProps) {
    return (
        <TripBoardsModalApolloProvider
            siteName={siteName}
            {...tripBoardProviderSearchParams}
            isLoggedIn={isLoggedIn}
            autosave
            showCoachmark
        />
    );
}

function mapStateToProps(state) {
    const {searchParams} = state;

    const {
        adultsCount,
        arrival: startDate,
        childrenCount,
        departure: endDate,
        petIncluded,
        q: searchTerm
    } = searchParams.params;

    return {
        tripBoardProviderSearchParams: {
            startDate,
            endDate,
            adultsCount,
            petIncluded,
            searchTerm,
            childrenCount
        }
    };
}

export default connect(mapStateToProps)(TripBoardsProviderContainer);
